import {auth} from '../firebase';
import {signInAnonymously} from 'firebase/auth';
let pending;
export function readyAuth(){
 if(!pending) pending=(async()=>{await auth.authStateReady();if(!auth.currentUser)await signInAnonymously(auth);return auth.currentUser;})().catch(e=>{pending=null;throw e});
 return pending;
}
